window.addEventListener("DOMContentLoaded", () => {
    const nav_items = document.querySelectorAll(".prime-nav-content .prime-nav-item");
    let navObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach((entry)=> {
        if (entry.isIntersecting) {
          let item = document.querySelector(`[data-id="${entry.target.id}"]`)
          activeItem(item)
        }
      });
    });

    Array.from(nav_items).forEach((item) => {
      const box = document.getElementById(item.dataset.id);
      navObserver.observe(box)
      item.onclick = () => {
        // activeItem(item)
        box.scrollIntoView({ behavior: "smooth" });
      };
    });

    function activeItem(item){
      $(nav_items).not(item).removeClass("active");
      item.classList.add("active");
    }
  });
  